export const BATCH_CAPABLE_LLMS = [
  "gpt-6.1",
  "gpt-6.1-search-enabled",
  "gpt-5.2",
  "gpt-5.6",
  "gpt-5.2-search-enabled",
  "gpt-5.6-search-enabled",
  "Claude-4.6",
  "Claude-5",
  "Claude-5.5",
  "Claude-5.5-Haiku",
  "Claude-5.5-Sonnet-Search",
  "Claude-4.5-Search",
  "Claude-5-Search",
  "Claude-5.5-Search",
  "Gemini-3.1",
  "Gemini-3.1-Search",
  "Gemini-3.8-Flash",
  "Gemini-3.8-Flash-Search",
];

export function isBatchCapableLlm(llm) {
  return !!llm && BATCH_CAPABLE_LLMS.includes(llm);
}
export function hasBatchCapableLlm(llmOrLlms) {
  if (Array.isArray(llmOrLlms)) return llmOrLlms.some(isBatchCapableLlm);
  return isBatchCapableLlm(llmOrLlms);
}
